// @flow
import * as React from 'react';
import { Checkbox } from 'react-bootstrap';

import './checkboxStyle.css';
import type { Props } from './Props';
import style from './style';

const Search = ({ name, picture, checked = true, onToggle = () => {} }: Props): React.Element<any> => (
  <Checkbox bsClass="userSelect" checked={checked} onChange={() => onToggle()}>
    <img style={style.image} alt={name} src={picture} />
    <span style={style.text}>{name}</span>
  </Checkbox>
);

export default Search;



// WEBPACK FOOTER //
// ./src/scenes/Admins/components/AdminSettings/components/UserSelect/components/UserRow/UserRow.js